import React from "react";
import ShipLibrary from "../components/ShipLibrary";
import MMTopPane from "../components/MMTopPane";
import { BrowserRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import Login from "../components/Login";
import ErrorMessage from "../components/ErrorMessage";
import ClientDashboardLibrary from "../components/ClientDashboardLibrary";
import PendingStatusScreen from "./PendingShipsDashboard";
import PendingShipEdit from "./PendingShipEdit";
import PendingShipDetails from "./PendingShipDetails";
import GrandAdminPendingDashboard from "./GrandAdminPendingDashboard";
import FlagDetails from "./FlagDetails";
import ClassDetails from "./Lookup/ClassDetails";
import ShipEquipmentDetails from "./ShipEquipmentDetails";
import ShipEquipmentEdit from "./ShipEquipmentEdit";
import MMPLDashboard from "../components/MMPLDashboard";
import ServiceUpdate from "../components/MMPLServiceUpdate";
import EquipmentUpdate from "../components/EquipmentUpdate";
import LookupFilter from "../components/Lookup/LookupFilter";
import LookupEdit from "../components/Lookup/LookupEdit";
import LookupAdd from "../components/Lookup/LookupAdd";
import ShipManagementNewItem from "../components/ShipManagementNewItem";
import ShipManagementEditItem from "../components/ShipManagementEditItem";
import ShipManagement from "../components/ShipManagement";
import InactiveShipDashboard from "./InactiveShipDashboard";
import InactiveShipDetail from "./InactiveShipDetail";
import InactiveShipEditItem from "./InactiveShipEditItem";
import VendorManagementNewItem from "../components/AddVendor";
import VendorManagementEditItem from "../components/EditVendor";
import VendorManagement from "../components/VendorManagement";
import VendorManagementDetails from "./VendorManagementDetails";
import VendorListTable from "./VendorListTable";
import VendorZoneTable from "./VendorZoneTable";
import VendorEquipmentsTable from "./VendorEquipmentsTable";
import newEquipment from "../components/newEquipment";
import editEquipment from "../components/editEquipment";
import ClientManagement from "../components/ClientMangement";
import ContractManagement from "../components/ContractManagement";
import EditContract from "../components/EditContracts";
import ShipDetails from "../components/ShipDetails";
import newFleetManager from "./newFleetManager";
import newTechSuperintendent from "./newTechSuperintendent";
import newTechExecutive from "./newTechExecutive";
import EditFleetManager from "./EditFleetManager";
import EditSuperintendent from "./EditSuperintendent";
import BudgetListView from "./BudgetListView";
import ServiceUpdateList from "./EquipmentUpdateListView";
import InisiateContractListView from "./InisiateContractListView";
import EditExecutive from "./EditExecutive";
import EquipmentManagement from "../components/EquipmentMgmtListScreen";
import EquipmentNewScreen from "../components/EquipmentMgmtNewScreen";
import EquipmentUpdateScreen from "../components/EquipmentMgmtUpdateScreen";
import PortManagement from "../components/PortManagement";
import EditPort from "../components/EditPort";
import AddPort from "../components/AddPort";
import ServicedBy from "../components/ServicedBy";
import EditService from "../components/EditService";
import AddService from "../components/AddService";
import ShipManagementDetail from "../components/ShipManagementDetail";
import UserManagement from "../components/UserManagement";
import MMPLUserEdit from "../components/MMPLUserEdit";
import EquipmentMgmtDetail from "../components/EquipmentMgmtDetail";
import ClientManagementDetail from "../components/ClientManagementDetail";
import ClientManagementEdit from "../components/ClientManagementEdit";
import userRoles from "../helpers/role";
import ClientUserManagement from "./ClientUserManagement";
import ShipUserManagement from "./ShipUserManagement";
import EditClientUser from "./EditClientUser";
import EditShipUser from "./EditShipUser";
import AddContract from "./AddContract";
import PageLoader from "../Shared/PageLoader";
import { hideLoader, showLoader } from "../Actions/PageLoaderAPI";
import axios from "axios";
import StaffManagement from "./StaffManagement";
import StaffManagementEdit from "./StaffManagementEdit";
import StaffManagementAdd from "./StaffManagementAdd";
import StaffManagementDetail from "./StaffManagementDetail";
import ClientContactUserManagement from "./ClientContactUserManagement";
import ClientContactUserDetail from "./ClientContactUserDetail";
import ClientContactUserEdit from "./ClientContactUserEdit";
import EquipmentView from "./EquipmentView";
import FlagSearch from "./FlagSearch";
import FlagAdd from "./FlagAdd";
import FlagEdit from "./FlagEdit";
import MakeSearch from "../components/Lookup/Make";
import MakeAdd from "../components/Lookup/MakeAdd";
import MakeEdit from "./Lookup/MakeEdit";
import ClassSearch from "../components/Lookup/Class";
import ClassAdd from "../components/Lookup/ClassAdd";
import ClassEdit from "../components/Lookup/ClassEdit";
import MiscSearch from "../components/Lookup/Misc";
import MiscAdd from "../components/Lookup/MiscAdd";
import MiscEdit from "../components/Lookup/MiscEdit";
import ControlledDocuments from "./ControlledDocuments";
import ControlledDocAdd from "./ControlledDocAdd";
import ControlledDocView from "./ControlledDocView";
import ControlledDocFileAdd from "./ControlledDocFileAdd";
import HistoryofActions from "./HistoryofActions";
import EquipmentZoneCostManagement from "./EquipmentZoneCostManagement"
import EquipmentServiceTypes from "./EquipmentServiceTypes";
import MDSubBanner from "./MDSubBanner";
import ChangePassword from "../components/ChangePassword";
import Notes from "../components/NotesMngListscreen";
import AddNote from "../components/AddNewNotes";
import EditNotes from "./EditNotes";
import NoteDetails from "./NoteDetails";
import ApproverDashboard from "./ApproverDashboard";
import ApproverServiceUpdate from "./ApproverServiceUpdate";
import PendingApproval from "./PendingApproval";
import PendingApprovalList from "./PendingApprovalList";
import PendingApprovalDetails from "./PendingApprovalDetails";
import ServiceBudgetHistory from "./ServiceBudgetHistory";
import AdhocAnalysis from "./AdhocAnalysis";
import { Router } from "react-router-dom/cjs/react-router-dom.min";
import ShipCostManagement from "./ShipCostManagement";

let user = localStorage.getItem("UserRoles");

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rolename: "",
    };
  }

  componentWillMount() {
    let activeRequests = 0;
    const { dispatch, match } = this.props;
    axios.interceptors.request.use(
      (config) => {
        if (!config.skipGlobalLoader) {
          activeRequests += 1;
          dispatch(showLoader());
        }
        const userDetails = localStorage.getItem("currentUser");
        let userToken = JSON.parse(userDetails);
        if (userToken) {
          config.headers["Authorization"] = "Bearer " + userToken.accessToken;
        }
        return config;
      },
      function (error) {
        // dispatch(hideLoader());
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      function (response) {
        if (!response.config.skipGlobalLoader) {
          activeRequests -= 1;
          if (activeRequests === 0) {
            dispatch(hideLoader());
          }
        }
        return response;
      },
      function (error) {
        if (!error.config || !error.config.skipGlobalLoader) {
          activeRequests -= 1;
          if (activeRequests === 0) {
            dispatch(hideLoader());
          }
        }
        return Promise.reject(error);
      }
    );
  }

  render() {
    const {
      showSidePane,
      showShipDetailsPane,
      showEquipmentDetailsPane,
      showMMPLDetailsPane,
      showContractDetailsPane,
      showServiceUpdatePane,
      editShipDetailsPane,
      editEquipmentDetailsPane,
      ShipeditEquipment,
      Role,
      equipmentServiceTypeDetail,
      ShowNoteSidePan,
    } = this.props;

    return (
      <div
        className="full-height"
        style={{ width: "100%" /* ,marginTop:"-40px"*/ }}
      >
        <BrowserRouter>
          <Route
            path="/Home"
            render={() => {
              return window.location.href.indexOf("/Home/BudgetListView") !==
                -1 ? null : (
                <Route path="/Home" component={MMTopPane}></Route>
              );
            }}
          />
          <Route
            path="/Home"
            render={() => {
              return window.location.href.indexOf("/Home/Shipmanagement") !==
                -1 ? null : (
                <Route path="/Home" component={MDSubBanner}></Route>
              );
            }}
          />
          <Route
            path="/Home/ApproverDashboard"
            component={ApproverDashboard}
          ></Route>
          <Route
            exact
            path="/Home/PendingApprovals"
            component={PendingApproval}
          ></Route>
          <Route
            path="/Home/PendingApprovals/:id/Equipments"
            component={PendingApprovalList}
          ></Route>
          <Route
            path="/Home/PendingApprovals/:id/Equipments/:itemId"
            component={PendingApprovalDetails}
          ></Route>
          {/* <Route path="/Home/MyPendingTasks" component={MyPendingTasks}></Route> */}
          {user == userRoles.staff ? (
            <div className="row px-4">
              <div
                className={`${showEquipmentDetailsPane || editEquipmentDetailsPane
                  ? "col-sm-12 col-md-6 col-lg-6 mobile"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                  } `}
              >
                <Route path="/Home/ShipDetails" component={ShipLibrary}></Route>
              </div>

              {showEquipmentDetailsPane || editEquipmentDetailsPane ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    exact
                    path="/Home/ShipDetails/Equipment/:id/:shipId"
                    component={ShipDetails}
                  ></Route>
                  <Route
                    exact
                    path="/Home/ShipDetails/EquipmentEdit/:id/:type"
                    component={EquipmentUpdate}
                  ></Route>
                </div>
              ) : null}
            </div>
          ) : (
            <div className="row px-4">
              <div
                className={`${showEquipmentDetailsPane
                  ? "col-sm-12 col-md-6 col-lg-6 mobile"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                  } `}
              >
                <Route
                  path="/Home/ShipDetails/:id"
                  component={ShipLibrary}
                ></Route>

                <Route
                  path="/Home/ServiceShipDetails/:id"
                  component={ShipLibrary}
                ></Route>
              </div>

              {showEquipmentDetailsPane ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    exact
                    path="/Home/ShipDetails/Equipment/:id/:shipId"
                    component={ShipDetails}
                  ></Route>
                  <Route
                    exact
                    path="/Home/ShipDetails/EquipmentEdit/:id/:type"
                    component={EquipmentUpdate}
                  ></Route>
                </div>
              ) : null}
            </div>
          )}

          <div className="row px-4">
            <div
              className={`${editEquipmentDetailsPane
                ? "col-sm-12 col-md-6 col-lg-6 mobile"
                : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                } `}
            >
              <Route
                path="/Home/EquipmentServiceTypes/:shipId/:equipId"
                component={EquipmentServiceTypes}
              ></Route>
            </div>
            {editEquipmentDetailsPane ? (
              <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                <EquipmentUpdate serviceDetail={equipmentServiceTypeDetail} />
                {/* <Route exact path="/Home/EquipmentServiceTypes/EquipmentEdit/:id/:type" component={EquipmentUpdate}></Route> */}
              </div>
            ) : null}
          </div>

          {user == userRoles.client ? (
            <div className="row px-4">
              <div
                className={`${showSidePane
                  ? "col-sm-12 col-md-6 col-lg-6 mobile"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                  }`}
              >
                <Route
                  path="/Home/ClientDashboard"
                  component={ClientDashboardLibrary}
                ></Route>
              </div>
            </div>
          ) : null}

          {user == userRoles.mmpl || user == userRoles.mmpladmin ? (
            <div className="row px-4">
              <div
                className={`${showMMPLDetailsPane
                  ? "col-sm-12 col-md-6 col-lg-6 mobile"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                  } `}
              >
                <Route
                  path="/Home/MMPLDashboard"
                  component={MMPLDashboard}
                ></Route>
              </div>
            </div>
          ) : null}

          <div className="row px-4">
            <div
              className={
                showContractDetailsPane
                  ? "col-sm-12 col-md-6 col-lg-6 mobile"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
              }
            >
              <Route
                path="/Home/Contracts"
                component={ContractManagement}
              ></Route>
            </div>
            {showContractDetailsPane ? (
              <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                <Route
                  path="/Home/Contracts/:id"
                  component={EditContract}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div
              className={`${showSidePane ? "col-sm-6 mobile" : "col-lg-12"} `}
            >
              <Route path="/Home/AddContract" component={AddContract}></Route>
            </div>
          </div>

          <div className="row px-4 align-items-start">
            <div
              className={`${
                showSidePane ? "col-12 col-lg-6" : "col-12"
              } `}
            >
              <Route
                exact
                path="/Home/Management/Staff"
                component={StaffManagement}
              ></Route>
              <Route
                path="/Home/Management/Staff/:id([0-9]+)"
                component={StaffManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-12 col-lg-6 um-client-sidepane-column">
                <Route
                  path="/Home/Management/Staff/:id([0-9]+)"
                  component={StaffManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/Staff/Add"
                component={StaffManagementEdit}
              ></Route>
              <Route
                path="/Home/Management/Staff/Edit/:id"
                component={StaffManagementEdit}
              ></Route>
              <Route
                path="/Home/Management/StaffAdd"
                component={StaffManagementAdd}
              ></Route>
              <Route
                path="/Home/Management/StaffEdit/:id"
                component={StaffManagementEdit}
              ></Route>
            </div>
          </div>

          <div className="row">
            <div
              className={`${showSidePane ? "col-sm-6 mobile" : "col-lg-12"} `}
            >
              <Route
                path="/Home/ServiceUpdate/:type"
                exact
                component={ServiceUpdate}
              ></Route>
            </div>
          </div>

          <Route
            path="/Home/ServiceUpdate"
            exact
            component={ServiceUpdate}
          ></Route>

          <Route path="/Error" component={ErrorMessage}></Route>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/ShipManagement"
                component={ShipManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/ShipManagement/:id"
                  component={ShipManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className={`${showSidePane ? "row px-4" : "row px-4"} `}>
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/ShipManagementEditItem/:id"
                component={ShipManagementEditItem}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/ShipManagementEditItem/:id/Equipment"
                  component={editEquipment}
                ></Route>
                <Route
                  path="/Home/ShipManagementEditItem/:id/NewEquipment"
                  component={editEquipment}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className={`${showSidePane ? "row px-4" : "row px-4"} `}>
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/ShipManagementNewItem"
                component={ShipManagementNewItem}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/ShipManagementNewItem/NewEquipment"
                  component={newEquipment}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/InactiveShip"
                component={InactiveShipDashboard}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/InactiveShip/:id"
                  component={InactiveShipDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className={`${showSidePane ? "row px-4" : "row px-4"} `}>
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/InactiveShipEditItem/:id"
                component={InactiveShipEditItem}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/InactiveShipEditItem/:id/Equipment"
                  component={editEquipment}
                ></Route>
                <Route
                  path="/Home/InactiveShipEditItem/:id/NewEquipment"
                  component={editEquipment}
                ></Route>
              </div>
            ) : null}
          </div>
          {user == userRoles.staff ? (
            <div className="row px-4">
              <div
                className={`${showEquipmentDetailsPane || editEquipmentDetailsPane
                  ? "col-sm-12 col-md-6 col-lg-6 mobile"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                  } `}
              >
                <Route
                  path="/Home/PendingShipDetails/:id"
                  component={ShipLibrary}
                ></Route>
              </div>

              {showEquipmentDetailsPane || editEquipmentDetailsPane ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    exact
                    path="/Home/PendingShipDetails/Equipment/:id/:shipId"
                    component={ShipDetails}
                  ></Route>
                  <Route
                    exact
                    path="/Home/PendingShipDetails/EquipmentEdit/:id/:type"
                    component={EquipmentUpdate}
                  ></Route>
                </div>
              ) : null}
            </div>
          ) : (
            <div className="row px-4">
              <div
                className={`${showEquipmentDetailsPane
                  ? "col-sm-12 col-md-6 col-lg-6 mobile"
                  : "col-sm-12 col-md-12 col-lg-12 col-lg-12"
                  } `}
              >
                <Route
                  path="/Home/PendingShipDetails/:id"
                  component={ShipLibrary}
                ></Route>
              </div>

              {showEquipmentDetailsPane ? (
                <div className="col-sm-12 col-md-6 col-lg-6 mobile">
                  <Route
                    exact
                    path="/Home/PendingShipDetails/Equipment/:id/:shipId"
                    component={ShipDetails}
                  ></Route>
                  <Route
                    exact
                    path="/Home/PendingShipDetails/EquipmentEdit/:id/:type"
                    component={EquipmentUpdate}
                  ></Route>
                </div>
              ) : null}
            </div>
          )}

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/GrandAdmin/PendingShipDetails"
                component={GrandAdminPendingDashboard}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/GrandAdmin/PendingShipDetails/:id"
                  component={ShipEquipmentDetails}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className={`${showSidePane ? "row px-4" : "row px-4"} `}>
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/GrandAdmin/ShipEditItem/:id"
                component={ShipEquipmentEdit}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/GrandAdmin/ShipEditItem/:id/Equipment"
                  component={editEquipment}
                ></Route>
                <Route
                  path="/Home/GrandAdmin/ShipEditItem/:id/NewEquipment"
                  component={editEquipment}
                ></Route>
              </div>
            ) : null}
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>

              <Route
                path="/Home/PendingShip"
                component={PendingStatusScreen}
              ></Route>

            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/PendingShip/:id"
                  component={PendingShipDetails}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className={`${showSidePane ? "row px-4" : "row px-4"} `}>
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/PendingShipEdit/:id"
                component={PendingShipEdit}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-lg-6">
                <Route
                  path="/Home/PendingShipEdit/:id/Equipment"
                  component={editEquipment}
                ></Route>
                <Route
                  path="/Home/PendingShipEdit/:id/NewEquipment"
                  component={editEquipment}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4 align-items-start">
            <div
              className={`${
                showSidePane ? "col-12 col-lg-6" : "col-12"
              } `}
            >
              <Route
                exact
                path="/Home/ClientManagement"
                component={ClientManagement}
              ></Route>
              <Route
                path="/Home/ClientManagement/:id([0-9]+)"
                component={ClientManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-12 col-lg-6 um-client-sidepane-column">
                <Route
                  path="/Home/ClientManagement/:id([0-9]+)"
                  component={ClientManagementDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ClientManagement/Add"
                component={ClientManagementEdit}
              ></Route>
              <Route
                path="/Home/ClientManagement/Edit/:id"
                component={ClientManagementEdit}
              ></Route>
              <Route
                path="/Home/AddNewClient"
                component={ClientManagementEdit}
              ></Route>
              <Route
                path="/Home/EditClient/:id"
                component={ClientManagementEdit}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/AddNewClient/NewFleetManager"
                component={newFleetManager}
              ></Route>
              <Route
                path="/Home/AddNewClient/NewTechSuperintendent"
                component={newTechSuperintendent}
              ></Route>
              <Route
                path="/Home/AddNewClient/NewExecutive"
                component={newTechExecutive}
              ></Route>
              <Route
                path="/Home/EditClient/:id/NewFleetManager"
                exact
                component={EditFleetManager}
              ></Route>
              <Route
                path="/Home/EditClient/:id/NewTechSuperintendent"
                exact
                component={EditSuperintendent}
              ></Route>
              <Route
                path="/Home/EditClient/:id/NewExecutive"
                exact
                component={EditExecutive}
              ></Route>
              <Route
                path="/Home/EditClient/:id/EditFleetManager"
                component={EditFleetManager}
              ></Route>
              <Route
                path="/Home/EditClient/:id/EditTechSuperintendent"
                component={EditSuperintendent}
              ></Route>
              <Route
                path="/Home/EditClient/:id/EditExecutive"
                component={EditExecutive}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-sm-6" : "col-lg-12"} `}>
              <Route
                path="/Home/EquipmentManagement"
                component={EquipmentManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-sm-6">
                <Route
                  path="/Home/EquipmentManagement/:id"
                  component={EquipmentMgmtDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row grey-bg">
            <div
              className={`${showSidePane ? "col-sm-6 mobile" : "col-lg-12"} `}
            >
              <Route
                path="/Home/AddNewEquipment"
                component={EquipmentNewScreen}
              ></Route>
            </div>
          </div>
          <div className="row grey-bg">
            <div
              className={`${showSidePane ? "col-sm-6 mobile" : "col-lg-12"} `}
            >
              <Route
                path="/Home/EditEquipment/:id"
                component={EquipmentUpdateScreen}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/MasterData/Flag"
                component={FlagSearch}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/MasterData/ClassDetails/:id"
                component={ClassDetails}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/MasterData/FlagDetails/:id"
                component={FlagDetails}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                exact
                path="/Home/Management/Users/MMPL"
                component={UserManagement}
              ></Route>
              <Route
                exact
                path="/Home/Management/Users/Client"
                component={ClientUserManagement}
              ></Route>
              <Route
                exact
                path="/Home/Management/Users/Ship"
                component={ShipUserManagement}
              ></Route>
            </div>
          </div>
          <div className="row px-4 align-items-start">
            <div
              className={
                showSidePane ? "col-12 col-lg-6" : "col-12"
              }
            >
              <Route
                exact
                path="/Home/Management/Users/ClientContacts"
                component={ClientContactUserManagement}
              ></Route>
            </div>
            {showSidePane ? (
              <div className="col-12 col-lg-6 um-client-sidepane-column">
                <Route
                  path="/Home/Management/Users/ClientContacts/:id"
                  component={ClientContactUserDetail}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Management/Users/ClientContacts/Add"
                component={ClientContactUserEdit}
              ></Route>
              <Route
                path="/Home/Management/Users/ClientContacts/Edit/:id"
                component={ClientContactUserEdit}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-12">
              <Route
                path="/Home/Management/Users/MMPL/Add"
                component={MMPLUserEdit}
              ></Route>
              <Route
                path="/Home/Management/Users/MMPL/Edit/:id"
                component={MMPLUserEdit}
              ></Route>
              <Route
                path="/Home/Management/AddUser"
                component={MMPLUserEdit}
              ></Route>
              <Route
                path="/Home/Management/EditUser/:id"
                component={MMPLUserEdit}
              ></Route>
              <Route
                path="/Home/Management/EditClientUser/:id"
                component={EditClientUser}
              ></Route>
              <Route
                path="/Home/Management/EdiShipUser/:id"
                component={EditShipUser}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className={`${showSidePane ? "col-sm-6 new" : "col-lg-12"} `}>
              <Route path="/Home/Lookup/:type" component={LookupFilter}></Route>
            </div>
            {showSidePane ? (
              <div className="col-sm-6">
                <Route
                  path="/Home/Lookup/:type/Edit/:id"
                  component={LookupEdit}
                ></Route>
                <Route
                  path="/Home/Lookup/:type/Add"
                  component={LookupAdd}
                ></Route>
              </div>
            ) : null}
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-sm-6 new" : "col-lg-12"} `}>
              <Route path="/Home/Port" component={PortManagement}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-sm-12">
              <Route path="/Home/PortAdd" component={AddPort}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-sm-12">
              <Route path="/Home/PortEdit/:id" component={EditPort}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-lg-6 new" : "col-lg-12"} `}>
              <Route
                path="/Home/VendorManagement"
                component={VendorManagement}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/VendorManagementNewItem"
                component={VendorManagementNewItem}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/VendorManagementDetails/:id"
                component={VendorManagementDetails}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/VendorManagementEditItem/:Equipid/:id"
                component={VendorManagementEditItem}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Vendor/EquipmentList"
                component={VendorEquipmentsTable}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/Vendor/ZoneList"
                component={VendorZoneTable}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/VendorList"
                component={VendorListTable}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className={`${showSidePane ? "col-sm-6 new" : "col-lg-12"} `}>
              <Route path="/Home/ServicedBy" component={ServicedBy}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-sm-12">
              <Route
                path="/Home/AddServiceProvider"
                component={AddService}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-sm-12">
              <Route
                path="/Home/EditServiceProvider/:id"
                component={EditService}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/View/Equipment/:id/:shipEquipID"
                component={EquipmentView}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/LookupClass" component={ClassSearch}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/LookupClassAdd" component={ClassAdd}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/LookupClassEdit/:id"
                component={ClassEdit}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/LookupFlag" component={FlagSearch}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/LookupFlagAdd" component={FlagAdd}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/LookupFlagEdit/:id"
                component={FlagEdit}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/LookupMisc" component={MiscSearch}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/LookupMiscAdd" component={MiscAdd}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/LookupMiscEdit/:id" component={MiscEdit}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/LookupMakeAndModel"
                component={MakeSearch}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/LookupMakeAndModelAdd"
                component={MakeAdd}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/LookupMakeAndModelEdit/:id"
                component={MakeEdit}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ControlledDocuments"
                component={ControlledDocuments}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ControlledDocumentsAdd"
                component={ControlledDocAdd}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ControlledDocumentsView/:id/Files"
                component={ControlledDocView}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ControlledDocumentsView/:id/FileAdd"
                component={ControlledDocFileAdd}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/HistoryofActions"
                component={HistoryofActions}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/CostManagement"
                component={EquipmentZoneCostManagement}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ShipCostManagement/:id"
                component={ShipCostManagement}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ServiceBudgetOverview/:contractId/:shipId"
                component={ServiceBudgetHistory}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/AdhocAnalysis"
                component={AdhocAnalysis}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/BudgetListView/:id"
                component={InisiateContractListView}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ServiceUpdateList/:id"
                component={ServiceUpdateList}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ContractListEdit/:id"
                component={BudgetListView}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/BudgetListEdit/:id"
                component={BudgetListView}
              ></Route>
            </div>
          </div>

          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/:shipid/Notes" component={Notes}></Route>
            </div>
            {/* <div className={ShowNoteSidePan ? "col-lg-6" : "col-lg-12"}>
              <Route path="/Home/Notes" component={Notes}></Route>
            </div>
            {ShowNoteSidePan &&
              <div className="col-lg-6">
                <Route path="/Home/:shipid/Notes/:id" component={NoteDetails}></Route>
              </div>
            } */}
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route path="/Home/:shipid/AddNote" component={AddNote}></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/:shipid/EditNote/:id"
                component={EditNotes}
              ></Route>
            </div>
          </div>
          <div className="row px-4">
            <div className="col-lg-12">
              <Route
                path="/Home/ChangePassword"
                component={ChangePassword}
              ></Route>
            </div>
          </div>
          {/* <Route exact path="/Home/ChangePassword" component={ChangePassword}></Route> */}
          <PageLoader />
        </BrowserRouter>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    SubBannerTitle: state.SubBannerrTitle || "MD Library",
    ShowMISidePan: state.ShowMISidePan || false,
    ShowRDSidePan: state.ShowRDSidePan || false,
    ShowEURegSidePan: state.ShowEURegSidePan || false,
    isAttachment: state.SidePanReducer.isAttachment
      ? state.SidePanReducer.isAttachment
      : false,
    IsSMDEdit: state.SidePanReducer.IsSMDEdit,
    isAuthenticated: state.SidePanReducer.isAuthenticated,
    ShowPanel: state.SidePanReducer.RightPan || false,
    showShipDetailsPane: state.SidePanReducer.ShowShipDetails || false,
    showEquipmentDetailsPane:
      state.SidePanReducer.ShowEquipmentDetails || false,
    editShipDetailsPane: state.SidePanReducer.EditShipDetails || false,
    editEquipmentDetailsPane:
      state.SidePanReducer.EditEquipmentDetails || false,
    equipmentServiceTypeDetail:
      state.SidePanReducer.EquipmentServiceTypeDetail || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    showContractDetailsPane:
      state.SidePanReducer.ShowContractDetailsPane || false,
    showServiceUpdatePane: state.SidePanReducer.ShowServiceUpdatePane || false,
    Role: state.SidePanReducer.UserRole || null,
    ShowNoteSidePan: state.ShipNotesReducer.ShowNoteSidePan,
    ShipeditEquipment: state.MasterScreenReducer.editEquipment || false,
  };
}

export default connect(mapStateToProps, null)(Layout);
